<template>
  <div>
    <div v-if="holdPortfolioWithInstructions">
      <PortfolioInstructionsDisplay
        :portfolio="holdPortfolioWithInstructions"
        :registryDevices="props.registryDevices"
      />
    </div>
    <p v-else class="mb-0 text-muted fs-8">
      {{ $t("hold_strategy.no_hold_instructions") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { getPortfolioWithGuaranteedInstructions } from "@/composables/usePortfolioUtils";
import PortfolioInstructionsDisplay from "@/dashboard/production_strategy/overview/PortfolioInstructionsDisplay.vue";
import type { Portfolio, RegistryDevice } from "@/types";
import { computed } from "vue";

export interface HoldStrategyOverviewProps {
  portfolios: Portfolio[];
  registryDevices: RegistryDevice[];
}

const props = defineProps<HoldStrategyOverviewProps>();

const holdPortfolioWithInstructions = computed(() => {
  const defaultHold = props.portfolios.find(
    (p) => p.portfolio_type === "HOLD" && p.is_default
  );

  return defaultHold
    ? getPortfolioWithGuaranteedInstructions(defaultHold)
    : null;
});
</script>
